import React from 'react';
import {BsInstagram, BsTelegram} from "react-icons/bs";

function SocialMedia(props) {
    return (
        <div className="app__social">
            <div>
                <a href="https://www.instagram.com/salvat0rzy" target="_blank" rel="noreferrer">
                    <BsInstagram/>
                </a>
            </div>
            <div>
                <a href="https://t.me/dend1i" target="_blank" rel="noreferrer">
                    <BsTelegram/>
                </a>
            </div>
        </div>
    );
}

export default SocialMedia;